import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.dark,
  },
  content: {
    padding: theme.spacing(5),
    textAlign: 'center',
  },
  grid: {
    minHeight: '100%',
    alignContent: 'center',
    alignItems: 'center',
  },
  button: {
    minWidth: '250px',
    minHeight: '50px',
    backgroundColor: '#FCC561',
    color: '#222A35',
    '&:hover': {
      background: '#a9a9a9',
    },
    borderRadius: 0,
  },
  loginImage: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    position: 'relative',
    background: `
      linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), 
      url(img/login_image.jpg)
    `,
    [theme.breakpoints.down('sm')]: {
      objectFit: 'contain',
      height: '200px',
    },
  },
  logoImage: {
    objectFit: 'cover',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      objectFit: 'contain',
      height: '50%',
      width: '50%',
    },
  },
  link: {
    color: '#222A35',
    fontFamily: 'Open Sans',
  },
  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
    color: '#222A35',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  formInput: {
    borderRadius: 0,
    border: '1px solid #222A35',
  },
  modalSuccessIcon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#FCC561',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  modalButton: {
    minHeight: '44px',
    backgroundColor: '#FCC561',
    color: '#222A35',
    '&:hover': {
      background: '#e5b050',
    },
    borderRadius: 0,
  },
}));

export default useStyles;
